import styled from 'styled-components';

import { Button as InnerButton } from '@xing-com/button';
import { Headline as InnerHeadline } from '@xing-com/typography';

import { FollowButton as InnerFollowButton } from '../../components/follow-button';

export const Headline = styled(InnerHeadline)`
  margin-top: var(--spaceXL);
  margin-bottom: var(--spaceL);
`;

export const FollowButton = styled(InnerFollowButton)`
  margin-left: auto;
`;

export const RemoveButton = styled(InnerButton)`
  padding-left: 0;
`;
